import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { SolicitacaoDiretorTecnicoService } from '@/core/api/sicom-api/servicos/pessoa-juridica/solicitacao-diretor-tecnico/solicitacao-diretor-tecnico.service';
import type { SolicitacaoDiretorTecnicoRequest, SolicitacaoDiretorTecnicoResponse } from '@/core/api/sicom-api/servicos/pessoa-juridica/solicitacao-diretor-tecnico/solicitacao-diretor-tecnico.model';

@Injectable({ providedIn: 'root' })
export class SolicitacaoDiretorTecnicoServicosService {
    constructor(private api: SolicitacaoDiretorTecnicoService) {}

    consultar(params: SolicitacaoDiretorTecnicoRequest, context?: HttpContext): Observable<SolicitacaoDiretorTecnicoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }
}
